import { Hook } from '../hooks-manager';
export const topLevelPropsExtractorPlugin = extractDataFields => _ref => {
  let {
    hooksManager
  } = _ref;
  hooksManager.tap(Hook.beforeReport, eventPayload => {
    extractDataFields.forEach(field => {
      const {
        data
      } = eventPayload;
      if (data && typeof data[field] !== 'undefined') {
        eventPayload[field] = data[field];
        data[field] = undefined;
      }
    });
  });
};
//# sourceMappingURL=top-level-props-extractor-plugin.js.map